import { render, staticRenderFns } from "./labDetail.vue?vue&type=template&id=5b9bab65&scoped=true&"
import script from "./labDetail.vue?vue&type=script&lang=js&"
export * from "./labDetail.vue?vue&type=script&lang=js&"
import style0 from "./labDetail.vue?vue&type=style&index=0&id=5b9bab65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9bab65",
  null
  
)

export default component.exports